export default {
  welcomeToUbdiNotice: 'WelcomeToUbdiNotice',
  dataSourcesNotice: 'DataSourcesNotice',
  dataSourceNotSellingNotice: 'DataSourceNotSellingNotice',
  onboardingStepsModal: 'OnboardingStepsModal'
}
